import { COLOR_TEXTFIELD_LIGHT, COLOR_WH } from '../colors.constants';

export const colorsAccordion = {
  accordionBackground: COLOR_WH,
  accordionBackgroundSecondary: COLOR_TEXTFIELD_LIGHT,
};
